<template>
  <div class="product-page-search">
    <Textbox
      placeholder="Search for a product"
      type="search"
      @search="handleSearch"
    />
  </div>
</template>

<script>
import Textbox from "@/components/UI/Textbox.vue";
export default {
  name: "ProductPageSearch",
  components: { Textbox },
  props: {
    searchRoute: {
      type: String,
      default: "/products",
    },
  },
  methods: {
    handleSearch(e) {
      const route = this.$router.resolve({
        route: this.searchRoute,
        query: {
          search: e.value,
        },
      });
      window.open(route.href);
    },
  },
};
</script>

<style>
.product-page-search {
  background-color: var(--rofix-lighter-gray);
  padding: 2.4rem;
}

.product-page-search h3 {
  margin: 0 0 1.3rem;
}
</style>
